import React from 'react';
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {
    IAdvancedStrategyFiltersEditorViewModel
} from "../../../services/games-filter/strategies/advanced-filter/advanced-strategy-filters-editor-view-model.interface";
import {FilterCategoriesListComponent} from './filter-categories-list/filter-categories-list.component';
import {AdvancedGamesFilterBox} from "./boxes/advanced-games-filter.box";
import {AdvancedGamesFilterFooterBox} from "./boxes/advanced-games-filter-footer.box";
import {AdvancedGamesFilterHeaderBox} from "./boxes/advanced-games-filter-header.box";
import {
    AdvancedGamesFilterButtonBox,
    AdvancedGamesFilterButtonStyleBox
} from "./boxes/advanced-games-filter-button.box";
import {FilterByBox} from "./filter-categories-list/boxes/filter-by.box";
import {CyClass} from "../../../../common/cy-classes";
import {FilterCategoriesListBox} from "./boxes/filter-categories-list.box";


interface AdvancedGamesFilterComponentProps {
    filtersEditor: IAdvancedStrategyFiltersEditorViewModel;
}

export const AdvancedGamesFilterComponent = observer(
    class AdvancedGamesFilterComponent extends OrbitComponent<AdvancedGamesFilterComponentProps> {

        private _onApply = async () => {
            await this.props.filtersEditor.applyFilters();
            this.services.drawer.right.back();
        }

        private _onCancel = () => {
            this.props.filtersEditor.closeFilters();
        }

        private _onClearAll = async () => {
            await this.props.filtersEditor.clearFilters();
        }

        componentDidMount() {
            super.componentDidMount();
            this.props.filtersEditor.openFilters();
        }


        render() {
            const CloseIcon = this.services.theme.currentTheme.icons.closeIcon;
            const numberOfGamesIfUserApply: number = this.props.filtersEditor.getNumberOfGamesBeforeUserApply();
            const numberOfSelectedFilters: number = this.props.filtersEditor.getAppliedFiltersIds().length;

            return (
                <AdvancedGamesFilterBox className={CyClass('cy-advanced-filters')}>
                    <AdvancedGamesFilterHeaderBox>
                        <FilterByBox>
                            {this.services.translation.translate('FILTER_BY')}
                        </FilterByBox>
                        <button onClick={this._onCancel} className={CyClass('cy-close-advanced-filters-x-button')}>
                            <CloseIcon />
                        </button>
                    </AdvancedGamesFilterHeaderBox>
                    <FilterCategoriesListBox>
                        <FilterCategoriesListComponent filtersEditor={this.props.filtersEditor}/>
                    </FilterCategoriesListBox>
                    <AdvancedGamesFilterFooterBox>
                        <AdvancedGamesFilterButtonStyleBox preset="secondary" onClick={this._onClearAll} className={CyClass('cy-clear-filters-button')}>
                            {this.services.translation.translate('CLEAR_ALL')}
                        </AdvancedGamesFilterButtonStyleBox>

                        <AdvancedGamesFilterButtonBox preset="primary" onClick={this._onApply} className={CyClass('cy-apply-filters-button')}>
                            {this.services.translation.translate('APPLY') + (numberOfSelectedFilters> 0 ? ` (${numberOfGamesIfUserApply})` : '')}
                        </AdvancedGamesFilterButtonBox>
                    </AdvancedGamesFilterFooterBox>

                </AdvancedGamesFilterBox>
            )
        }
    }
);